import { convertLbsToGrams } from '~/utils/weight';

export const list = (dispatch, apiClient) => {
  dispatch({ type: 'KITS_PENDING' });
  return apiClient
    .call({
      endpoint: 'packs/list'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'KITS_LIST', list: res.data });
    })
    .catch(e => {
      dispatch({ type: 'KITS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get kit list",
        snackType: 'warning'
      });
      throw e;
    });
};

export const add = (dispatch, apiClient, name, sku, toSku, weight, count) => {
  dispatch({ type: 'KITS_PENDING' });
  return apiClient
    .call({
      endpoint: 'packs/add',
      data: { name, sku, toSku, weight: convertLbsToGrams(weight), count }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      list(dispatch, apiClient);
    })
    .catch(e => {
      dispatch({ type: 'KITS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't add kit",
        snackType: 'warning'
      });
      throw e;
    });
};

export const remove = (dispatch, apiClient, sku) => {
  dispatch({ type: 'KITS_PENDING' });
  return apiClient
    .call({
      endpoint: 'packs/remove',
      data: { sku }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      list(dispatch, apiClient);
    })
    .catch(e => {
      dispatch({ type: 'KITS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't remove pack",
        snackType: 'warning'
      });
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/kits.js